import { z } from "zod";
import { DecimalStringSchema, Rfc3339MillisSchema, UuidSchema } from "./primitives.js";
const NoteTextArraySchema = z.array(z.string().trim().min(1).max(100)).max(100);
const FrontmatterExtraSchema = z.record(z.string().max(200), z.unknown());
export const NoteCreateCommandSchema = z
    .object({
    commandId: UuidSchema,
    noteId: UuidSchema,
    workspaceId: UuidSchema,
    projectId: UuidSchema.nullable().default(null),
    title: z.string().trim().max(500).nullable(),
    bodyMarkdown: z.string().max(1_048_576),
    aliases: NoteTextArraySchema.default([]),
    tags: NoteTextArraySchema.default([]),
    frontmatterExtra: FrontmatterExtraSchema.default({}),
})
    .strict();
export const NoteUpdateCommandSchema = z
    .object({
    commandId: UuidSchema,
    noteId: UuidSchema,
    revision: DecimalStringSchema,
    projectId: UuidSchema.nullable().optional(),
    title: z.string().trim().max(500).nullable().optional(),
    bodyMarkdown: z.string().max(1_048_576).optional(),
    aliases: NoteTextArraySchema.optional(),
    tags: NoteTextArraySchema.optional(),
    frontmatterExtra: FrontmatterExtraSchema.optional(),
    archived: z.boolean().optional(),
    promoted: z.boolean().optional(),
})
    .strict()
    .refine((value) => value.projectId !== undefined ||
    value.title !== undefined ||
    value.bodyMarkdown !== undefined ||
    value.aliases !== undefined ||
    value.tags !== undefined ||
    value.frontmatterExtra !== undefined ||
    value.archived !== undefined ||
    value.promoted !== undefined, { message: "At least one note change is required" });
export const NoteProjectionSchema = z
    .object({
    id: UuidSchema,
    workspaceId: UuidSchema,
    ownerAccountId: UuidSchema,
    projectId: UuidSchema.nullable(),
    title: z.string().max(500).nullable(),
    bodyMarkdown: z.string().max(1_048_576),
    aliases: NoteTextArraySchema,
    tags: NoteTextArraySchema,
    frontmatterExtra: FrontmatterExtraSchema,
    promotedAt: Rfc3339MillisSchema.nullable(),
    archivedAt: Rfc3339MillisSchema.nullable(),
    revision: DecimalStringSchema,
    createdAt: Rfc3339MillisSchema,
    updatedAt: Rfc3339MillisSchema,
})
    .strict();
export const NoteListSchema = z.object({ items: z.array(NoteProjectionSchema) }).strict();
//# sourceMappingURL=notes.js.map